var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "baseData" },
    _vm._l(_vm.baseData, function (item, index) {
      return _c(
        "div",
        { key: index, staticClass: "base-data-item base-data-item-greenbg" },
        [
          _c("div", { staticClass: "title" }, [_vm._v(_vm._s(item.title))]),
          _c("div", { staticClass: "item" }, [_vm._v(_vm._s(item.price))]),
        ]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }